/**
 * アプリケーション定数とマジックナンバーの定義
 */

// HTTPステータスコード
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

// データベース関連の定数
export const DATABASE = {
  LIMITS: {
    DEWS_PER_USER: 10,
    RAINDROPS_PER_DEW: 100,
    RAINDROPS_DISPLAY_LIMIT: 7,
    USERS_BATCH_SIZE: 10,
    ERROR_LOGS_LIMIT: 1000,
  },
  DELETED_COLLECTION_ID: -100,
  DEFAULT_SORT_ORDER: 0,
} as const;

// 時間関連の定数（ミリ秒）
export const TIME = {
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
  WEEK: 7 * 24 * 60 * 60 * 1000,
  MONTH: 30 * 24 * 60 * 60 * 1000,
} as const;

// サーバー設定
export const SERVER = {
  BASIC_AUTH_REALM: "Restricted",
} as const;

// 外部API関連
export const EXTERNAL_API = {
  RAINDROP: {
    BASE_URL: "https://api.raindrop.io",
    APP_BASE_URL: "https://app.raindrop.io",
    TIMEOUT: 10000,
  },
  TURSO_PLATFORM: {
    BASE_URL: "https://api.turso.tech",
    TIMEOUT: 10000,
  },
  FLY: {
    BASE_URL: "https://api.machines.dev",
    TIMEOUT: 10000,
  },
  RESEND: {
    BASE_URL: "https://api.resend.com",
    TIMEOUT: 10000,
  },
} as const;

// メール関連
export const EMAIL = {
  FROM_ADDRESS: "noreply@dewdropapp.com",
  TIMEOUT: 5000,
} as const;

// Slack通知関連
export const SLACK = {
  NOTIFICATION_TIMEOUT: 3000,
  MAX_MESSAGE_LENGTH: 3000,
  DEFAULT_IGNORED_ERROR_CODES: ["404", "403"],
} as const;

// アプリケーション設定
export const APP = {
  NAME: "Dewdrop",
  VERSION: "1.0.0",
  SUPPORT_EMAIL: "support@dewdropapp.com",
  DEFAULT_DOMAIN: "dewdropapp.com",
  DEFAULT_LOCALE: "en",
  DEFAULT_TIMEZONE: "UTC",
  // CONTACT_URL: "https://forms.gle/QE4BJedNudffqRUA9",
  CONTACT_URL: "https://docs.google.com/forms/d/e/1FAIpQLScIZ4e1ohk1WtUMdKp4oHIWRBlovH4Jo9Hjma9FGGfeQ_qnXA/viewform?usp=header",
} as const;

// サブスクリプション関連定数
export const SUBSCRIPTION = {
  STATUS: {
    FREE: "free",
    ACTIVE: "active",
    CANCELLED: "cancelled",
    PAST_DUE: "past_due",
    UNPAID: "unpaid",
  } as const,
  PLANS: {
    FREE: {
      NAME: "free",
      MAX_RAINDROPS_PER_DEW: 20,
      MAX_DEWS_HISTORY: 3,
      COLLECTION_EXCLUSION_ENABLED: true,
      MAX_EXCLUDED_COLLECTIONS: 1,
      PRICE_MONTHLY_USD: 0,
    },
    PAID: {
      NAME: "paid",
      MAX_RAINDROPS_PER_DEW: 100,
      MAX_DEWS_HISTORY: 30,
      MAX_DEWS_IN_DROPDOWN: 10,
      COLLECTION_EXCLUSION_ENABLED: true,
      MAX_EXCLUDED_COLLECTIONS: Infinity,
      PRICE_MONTHLY_USD: 2.99,
      PRICE_ANNUAL_USD: 29,
      PRICE_ANNUAL_MONTHLY_USD: 2.42,
    },
  } as const,
} as const;

// Stripe関連定数
export const STRIPE = {
  CURRENCY: "usd",
  BILLING_INTERVALS: {
    MONTHLY: "month",
    ANNUAL: "year",
  } as const,
  WEBHOOK_TIMEOUT: 10000,
  SUPPORTED_EVENTS: [
    "customer.subscription.created",
    "customer.subscription.updated",
    "customer.subscription.deleted",
    "invoice.payment_succeeded",
    "invoice.payment_failed",
  ] as const,
} as const;